export function PlaceholderPage({ title }: { title: string }) {
  return (
    <div>
      <h1 className="mb-1 text-lg font-semibold text-b4l-text">{title}</h1>
      <p className="text-[13px] text-b4l-text-dim">
        Modul în curs de dezvoltare — se adaugă în fazele următoare.
      </p>
    </div>
  )
}
